import { render, staticRenderFns } from "./newcontribute.vue?vue&type=template&id=bc013958&scoped=true&"
import script from "./newcontribute.vue?vue&type=script&lang=js&"
export * from "./newcontribute.vue?vue&type=script&lang=js&"
import style0 from "./newcontribute.vue?vue&type=style&index=0&id=bc013958&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc013958",
  null
  
)

export default component.exports